//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Action, Divider, Paper } from '@backmarket/design-system'

import ReviewItem from '../ReviewItem'

export default {
  components: {
    Action,
    Divider,
    Paper,
    ReviewItem,
  },
  props: {
    isMaxReviewsReached: {
      type: Boolean,
      default: false,
    },
    reviews: {
      type: Array,
      required: true,
    },
    buttonLabel: {
      type: String,
      required: true,
    },
  },
}
